var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldCheckRegular(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 99,
    viewBox: "0 0 93 99",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.284 16.185 50.084.716A9.135 9.135 0 0 0 46.512 0a9.17 9.17 0 0 0-3.577.715L5.737 16.185C2.273 17.61 0 20.998 0 24.575 0 74.52 36.696 99 46.48 99 56.034 99 93 74.888 93 24.575c0-3.577-2.267-6.965-5.716-8.39zM46.5 89.719c-18.89-7.85-37.2-32.234-37.2-64.97L46.5 9.28l37.2 15.469c0 33.606-19.065 57.429-37.2 64.97zm-10.83-41.96c-.737-.909-1.938-1.527-3.12-1.527-2.656 0-4.65 2.167-4.65 4.64 0 1.354.446 2.553 1.356 3.287l9.3 9.282c.872 1.044 2.073 1.353 3.294 1.353.503 0 2.22-.096 3.53-1.62l18.6-21.656a4.622 4.622 0 0 0 1.12-3.02c0-1.432-1.122-4.639-4.646-4.639a4.653 4.653 0 0 0-3.534 1.617L41.598 53.502l-5.929-5.743z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckRegular);
export default __webpack_public_path__ + "static/media/shield-check-regular.2cf4f0fb.svg";
export { ForwardRef as ReactComponent };